// src/pages/SettingsPage/components/GlobalAdminWorkspaceUserTable.tsx
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { NoteBlockContainer } from "../../note";
import {
  useAllUsers,
  useFetchAllUsers,
  useAppsFromAllSources,
  useAppIdToApp,
  useAddWorkspaceUser,
  useDeleteWorkspaceUser,
  useFetchAllWorkspaces,
  useUserIsAppOwner,
} from "../../../hook/settings";
import { initialWorkspaceUserFormData } from "./settings.contants";
import { WorkspaceUserFormData } from "./types/settings.types";
import { AddWorkspaceUserModal } from "./AddWorkSpaceUserModal";

export const GlobalAdminWorkspaceUserTable: React.FC = () => {
  const [appUsers, setAppUsers] = useAllUsers();
  const fetchAppUsers = useFetchAllUsers();
  const theme = useTheme();
  const apps = useAppsFromAllSources();
  const appIdToApp = useAppIdToApp();
  const [addUserModalOpen, setAddUserModelOpen] = useState(false);
  const [formData, setFormData] = useState<WorkspaceUserFormData>(
    initialWorkspaceUserFormData
  );
  const [appId, setAppId] = useState(apps?.[0]?.id); // Initial appId for modal
  const addWorkspaceUser = useAddWorkspaceUser();
  const deleteWorkspaceUser = useDeleteWorkspaceUser();
  const fetchAllWorkspaces = useFetchAllWorkspaces();
  const userIsAppOwnerHook = useUserIsAppOwner(); // Renamed

  useEffect(() => {
    fetchAllWorkspaces();
  }, []);

  useEffect(() => {
    fetchAppUsers();
  }, []);

  // Update initial appId for modal if apps load later
  useEffect(() => {
    if (!appId && apps.length > 0) {
      setAppId(apps[0].id);
    }
  }, [apps, appId]);

  return (
    <>
      <AddWorkspaceUserModal
        appId={appId!}
        formData={formData}
        setFormData={setFormData}
        modalOpen={addUserModalOpen}
        setModelOpen={setAddUserModelOpen}
        onSubmit={({ formData: { email, name }, appId: modalAppId }) => {
          addWorkspaceUser({ email, name, appId: modalAppId });
        }}
        appSelector={true}
      />
      <NoteBlockContainer name="All Workspace Users">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Email</TableCell>
                <TableCell>Workspace</TableCell>
                <TableCell>Name</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {appUsers.map((appUser, i) => {
                const app = appIdToApp(appUser["app-id"]);

                return (
                  <TableRow key={`${appUser.email}-${appUser["app-id"]}-${i}`}>
                    <TableCell>{appUser.email}</TableCell>
                    <TableCell>{app?.name ?? "N/A"}</TableCell>
                    <TableCell>{appUser.name}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() =>
                          deleteWorkspaceUser({
                            appId: appUser["app-id"],
                            email: appUser.email,
                          })
                        }
                        disabled={userIsAppOwnerHook({
                          email: appUser.email,
                          appId: appUser["app-id"],
                        })}
                        sx={{ color: theme.palette.primary.main }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Box sx={{ justifyContent: "end", display: "flex" }}>
            <IconButton
              onClick={() => {
                setAddUserModelOpen(true);
              }}
              sx={{ color: theme.palette.primary.main }}
            >
              <AddIcon />
            </IconButton>
          </Box>
        </TableContainer>
      </NoteBlockContainer>
    </>
  );
};
